/**
 * 旅行保险相关 API
 */
import { get, post } from './index';

// ==================== 产品相关 ====================

/**
 * 获取产品列表
 */
export const getProductList = () => {
  return get('/api/ibenterprise/public/open/v1/individual_product/product/list');
};

/**
 * 查询个险产品方案列表
 */
export const getPlanList = (productId) => {
  return get('/api/ibenterprise/public/open/v1/individual_product/plan/list', { productId });
};

/**
 * 根据方案ID查询保障责任列表
 */
export const getCoverageList = (planId) => {
  return get('/api/ibenterprise/public/open/v1/individual_product/coverage/list', { planId });
};

// ==================== 投保相关 ====================

/**
 * 个险保单提交接口
 */
export const submitOrder = (orderData) => {
  return post('/api/ibenterprise/public/open/v1/individual_order/submit', orderData);
};

/**
 * 上传文件接口
 */
export const productUploadFile = (fileType, file) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('fileType', fileType || 'excel');
  return post('/api/ibenterprise/public/open/v1/fileOpen/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

/**
 * 被保人数据导入接口
 */
export const importProductData = (path) => {
  return post('/api/ibenterprise/public/open/v1/individual_product/import_data', path);
};

// ==================== 保单相关 ====================

/**
 * 查询个险保单列表
 */
export const getPolicyList = (params) => {
  return post('/api/ibenterprise/public/open/v1/individual_policy_get/policyList', params);
};

/**
 * 下载电子保单
 */
export const getElectronicPolicy = (id) => {
  return get('/api/ibenterprise/public/open/v1/individual_policy_get/electronicPolicyById', { id });
};

/**
 * 申请退保
 */
export const standardCancel = (id) => {
  return get('/api/ibenterprise/public/open/v1/individual_policy/standardCancel', { id });
};

/**
 * 查询保单人员列表
 */
export const getInsuredList = (params) => {
  return post('/api/ibenterprise/public/open/v1/individual_policy_get/getInsuredList', params);
};

/**
 * 导出保单人员列表
 */
export const exportInsuredList = (params) => {
  return post('/api/ibenterprise/public/open/v1/individual_policy_get/exportInsuredList', params, {
    responseType: 'blob'
  });
};

/**
 * 查询保单退保人员列表
 */
export const getCancelInsuredList = (params) => {
  return get('/api/ibenterprise/public/open/v1/individual_policy_get/getCancelInsuredList', params);
};

// ==================== 录屏相关 ====================

/**
 * 上传截图文件
 */
export const uploadScreenshot = (blob, fileName = 'screenshot.jpg') => {
  const formData = new FormData();
  formData.append('file', blob, fileName);
  return post('/api/monitor/file/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

/**
 * 提交录屏数据（录屏事件 + 截图链接）
 */
export const submitRecordingData = (data) => {
  return post('/app/api/recording/submit', data);
};

/**
 * 保存截图链接
 * @param {Object} data - { orderCode, screenshots }
 */
export const saveScreenshotLinks = (data) => {
  return post('/api/monitor/screenshot/saveScreenshots', data);
};

/**
 * 获取监控唯一编码
 * @param {string} orderCode - 订单编码
 */
export const getMonitorCode = (orderCode) => {
  return get('/api/monitor/detail/getMonitorCode', { orderCode });
};

/**
 * 保存录制内容（带唯一编码）
 * @param {Object} data - 录制数据
 */
export const saveMonitorDetail = (data) => {
  return post('/api/monitor/detail/save', data);
};

export default {
  getProductList,
  getPlanList,
  getCoverageList,
  submitOrder,
  productUploadFile,
  importProductData,
  getPolicyList,
  getElectronicPolicy,
  standardCancel,
  getInsuredList,
  exportInsuredList,
  getCancelInsuredList,
  uploadScreenshot,
  submitRecordingData,
  saveScreenshotLinks,
  getMonitorCode,
  saveMonitorDetail
};
